<template lang="pug">
  .component-kepler-file-upload
    .preview(v-if="previewUrl")
      .preview-image(v-if="canPreview", :style="previewStyle")
      .download-file(v-else)
        a(@click="openUrl")
          i.fa.fa-file-pdf-o.fa-3x
          br
          small {{previewUrl}}
      button.button.alert.small(@click="$emit('sel', null)", v-if="!previewOnly") Remove
    .uploader(v-if="!previewOnly")
      .input-group
        input.input-group-field(type='file', ref="file")
        .input-group-button
          input.button(type='submit', @click="startUpload", value="Upload")

      button.button.small(@click="advanced = !advanced") ADVANCED

    .advanced-upload(v-if="advanced")
      label VISIBILITY
        select(v-model="visibility")
          option(v-for="o in visibilityOptions") {{ o }}
      label PREFIX
        select(v-model="prefix", @change="listPublic")
          option(value="null", selected) no_prefix
          option(v-for="o in prefixOptions") {{ o }}

      label FILENAME
        input(type="text", v-model="filename", placeholder="filename")

      .uploaded-gallery(v-if="listing.length" )
        .card.ml-1(v-for="l in listing")
          div(:style="cardStyle(l)", v-if="preview(l)", @click="imageSelected(l)")
          div(v-else, :style="cardStyle(l)", @click="imageSelected(l)")
            .fa.fa-3x(:class="getMime(l)")
          div.p-1
            small.internal-path {{l.internal_path}}
          .buttons.p-1
            ActionButton(:button="false", :action="deleteFile", :confirm="true", :value="l.internal_path")
              .fa.fa-times(style="cursor: pointer; color: red;")
      template(v-else)
        h2 No images/files found on with selected prefix
</template>


<script>


import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import MdiIcon from "./ui/MdiIcon.vue";
import ActionButton from "./ui/ActionButton.vue";

export default {
  name: 'KeplerFileUpload',
  components: {ActionButton, MdiIcon},
  data() {
    return {
      response: null,
      prefix: '',
      visibility: null,
      filename: null,
      listing: [],
      advanced: false,
    }
  },

  mounted() {
    if (this.selectedPrefix) {
      this.prefix = this.selectedPrefix
    }
    if (this.selectedVisibility) {
      this.visibility = this.selectedVisibility
    }
    this.listPublic()
  },

  methods: {
    listPublic() {
      this.listing = null
      KeplerBackofficeSdk.files.list.public(this.prefix, (data) => {
        this.listing = data
      })
    },
    startUpload() {
      var file = this.$refs.file.files[0]
      KeplerBackofficeSdk.files.uploadImage(file, this.visibility, this.prefix, this.filename, (data) => {
        MaggieHelper.notification('upload', 'File uploaded successfully')

        this.$emit('sel', data.internal_path)
        this.listPublic()
      })

    },
    getMime(file) {
      switch (file.mime) {
        case 'pdf':
          return 'fa-file-pdf-o'
        case 'svg':
          return 'fa-file-code-o'
        default:
          return 'fa-file'
      }
    },
    imageSelected(l) {
      if (!this.selectable) {
        MaggieHelper.notification('upload', 'File path copied on the clipboard')
        navigator.clipboard.writeText(l.internal_path);
        return
      }
      this.$emit('sel', l.internal_path)
      MaggieHelper.notification('upload', 'File selected successfully')
      this.advanced = false
    },
    deleteFile(internalPath) {
      return KeplerBackofficeSdk.files.remove(internalPath, () => {
        MaggieHelper.notification('Deleted', 'File deleted sucessfully')
        this.listPublic()
      })

    },
    openUrl: function () {
      window.open(this.fileUrl, '_blank')
    },

    preview(file) {
      const extension = file.mime
      switch (extension) {
        case 'png':
        case 'jpg':
        case 'jpeg':
          return true
        default:
          return false
      }
    },
    cardStyle(item) {
      if (this.preview(item)) {
        return {
          backgroundImage: `url(${item.external_url})`,
          width: '100%',
          height: '150px',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          cursor: "pointer",
          flexGrow: 1

        }
      }
      return {
        height: '150px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: "pointer",
        flexGrow: 1
      }
    }
  },
  props: {
    visibilityOptions: {
      type: Array,
      default: function () {
        return [
          'public',
          'private'
        ]
      }
    },
    prefixOptions: {
      type: Array,
      default: function () {
        return [
          'vehicles',
          'vehicle-brands',
          'vehicle-categories',
          'parking-lot',
          'plans',
          'tocs',
          'vehicle-instructions',
          'damage-picture',
        ]
      }
    },
    selectedPrefix: {
      type: String
    },
    selectedVisibility: {
      type: String
    },
    previewUrl: {
      type: String
    },
    previewOnly: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    canPreview() {
      if (this.previewUrl) {
        const extension = this.previewUrl.split('.')[1]
        switch (extension) {
          case 'pdf':
            return false
          default:
            return true
        }
      }

      return false
    },
    previewStyle() {
      return {
        backgroundImage: `url(${this.fileUrl})`,
        height: '200px',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }
    },
    fileUrl() {
      return `${window.env.API_URL}/storage/${this.previewUrl}`
    },
  }
}
</script>
<style lang="sass">
.component-kepler-file-upload

  .uploader
    label
      display: block
      width: 140px

    input[type="text"], select
      width: 200px

  .preview

    margin: 10px 0
    text-align: center

    .button
      margin: 10px 0

  .advanced-upload
    .uploaded-gallery

      display: flex
      flex-wrap: wrap

      height: 300px
      width: 100%
      overflow: auto

      .card
        flex: 0 0 30%
        border: 1px solid #cacaca

        .buttons
          text-align: right

      .delete
        text-align: right
        padding: 0 3px
        color: red
        z-index: 5
        position: absolute
        right: 0

      .internal-path
        word-break: break-word

      .square
        height: 110px
        width: 110px
        position: relative
        border: 1px black solid
        border-radius: 10px
        margin: 10px
        display: inline-block

        &:hover
          border: 3px black solid
          cursor: pointer

        img, .other-file
          text-align: center
          max-width: 100%
          max-height: 100%
          top: 50%
          position: absolute
          transform: translateY(-50%)
          overflow: hidden

</style>



// WEBPACK FOOTER //
// KeplerFileUpload.vue?31626e2e